import React from 'react'
import {VOSVerificationPage} from './VOSVerificationPage'

type Mode = 'confirm' | 'dispute'

export const VOSLinkRouter: React.FC<{mode: Mode}> = ({mode}) => {
  return <VOSVerificationPage mode={mode} />
}
